import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }

import { computed, ref, watch } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxSetupStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const serviceTax = ref<string | number>("");

watch(
  () => props.profileInfo,
  (info) => {
    const tax = info?.tax_info || null;
    if (!tax) return;

    // Prefill only if user hasn't typed anything.
    if (serviceTax.value === "" && tax?.service_tax != null) {
      serviceTax.value = tax.service_tax;
    }
  },
  { immediate: true },
);

function getErrorsForField(field: string): string[] {
  const errs: any = props.errors;
  if (!errs) return [];

  const root = errs?.errors && typeof errs.errors === "object" ? errs.errors : errs;
  const raw = root?.[field];
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((v) => String(v));
  return [String(raw)];
}

const serviceTaxErrors = computed(() => getErrorsForField("serviceTax"));

function getValues() {
  return {
    serviceTax: serviceTax.value,
  };
}

__expose({ getValues });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-receipt-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "Tax setup"),
        _createElementVNode("p", { class: "desc" }, " Set up your service tax rate. ")
      ], -1))
    ]),
    _createVNode(_component_v_form, { class: "form" }, {
      default: _withCtx(() => [
        _createVNode(AppTextField, {
          modelValue: serviceTax.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceTax).value = $event)),
          type: "number",
          label: "Service Tax (%)",
          "label-icon": "",
          placeholder: "e.g. 13",
          "error-messages": serviceTaxErrors.value
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    })
  ]))
}
}

})